import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[sparkPasteDigitsOnly]'
})
export class SparkPasteDigitsOnlyDirective {
  @Output() sparkPasteDigitsOnly = new EventEmitter<string>();

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const pastedText = event.clipboardData?.getData('Text') || '';
    const digitsOnly = pastedText.replace(/\D/g, '');

    const input = event.target as HTMLInputElement | null;
    if (input?.value !== undefined) {
      input.value = digitsOnly;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    this.sparkPasteDigitsOnly.emit(digitsOnly);
  }
}
